(() => {
  if (customElements.get('boxy-category-nav')) return;
  customElements.define('boxy-category-nav', class extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      const options = { signal: this._controller.signal };
      const track = this.querySelector('[data-nav-track]');
      const controls = this.querySelector('[data-nav-controls]');
      const prev = this.querySelector('[data-nav-prev]');
      const next = this.querySelector('[data-nav-next]');
      if (!track || !controls || !prev || !next) return;
      const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const update = () => {
        const overflow = track.scrollWidth - track.clientWidth;
        controls.hidden = overflow <= 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= overflow - 2;
      };
      const move = direction => track.scrollBy({ left: direction * Math.max(160, track.clientWidth * .72), behavior: reduced() ? 'auto' : 'smooth' });
      prev.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      track.addEventListener('scroll', update, { ...options, passive: true });
      // Keep the focused category visible for keyboard users without moving focus.
      track.addEventListener('focusin', event => {
        const card = event.target.closest('a');
        if (!card) return;
        const rail = track.getBoundingClientRect();
        const item = card.getBoundingClientRect();
        if (item.left < rail.left) track.scrollBy({ left: item.left - rail.left - 4, behavior: 'auto' });
        else if (item.right > rail.right) track.scrollBy({ left: item.right - rail.right + 4, behavior: 'auto' });
      }, options);
      if ('ResizeObserver' in window) {
        this._observer = new ResizeObserver(update);
        this._observer.observe(track);
      } else window.addEventListener('resize', update, options);
      requestAnimationFrame(() => {
        const active = track.querySelector('.is-current');
        if (active) {
          // Preserve the page's vertical position: adjust only this rail.
          const rail = track.getBoundingClientRect();
          const item = active.getBoundingClientRect();
          track.scrollLeft = Math.max(0, track.scrollLeft + item.left - rail.left - (rail.width - item.width) / 2);
        }
        update();
      });
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._controller = null;
      this._observer?.disconnect();
      this._observer = null;
    }
  });
})();
